<template>
  <div class="hero-container mb-7">

    <div class="row hero-section justify-content-center no-gutters">
      <div class="mx-4">
        <h1>{{ $t(headerText) }}</h1>
        <h5>{{ $t(subText) }}</h5>
      </div>
      <div v-on:click="scroll_first_section" class="scroll-icon">
          <p class="scroll-text">{{ $t('message.hero.scroll') }}</p>
          <img src="/static/images/icons/icon_scroll_arrow.svg" />
      </div>
    </div>

    <div class="row slanted-container-right">
        <!--<div class="col-12 scroll-icon">
           <img v-on:click="scroll_first_section" width="50px" src="/static/images/scroll-icon.png" />
        </div>-->
    </div>

    <div v-if="should_display_scroll_up(1)" class="scroll-up-icon justify-content-end d-none d-md-flex">
      <img v-on:click="scroll_up" src="/static/images/icons/icon_scroll_blue.svg" />
    </div>

  </div>
</template>

<script>
export default {
  props: {
    subText: String,
    headerText: String,
  },
  name: 'PageHero',
  data() {
    return {
      displayScrollUp: 0,
    };
  },
  mounted() {
    this.when_ready();
  },
  methods: {
    // eslint-disable-next-line
    scroll_first_section: function () {
      window.scroll({ top: window.innerHeight, left: 0, behavior: 'smooth' });
    },
    // eslint-disable-next-line
    scroll_listener: function () {
      // eslint-disable-next-line
      console.log('Scrolling!');
      if (window.pageYOffset >= window.innerHeight) {
        this.displayScrollUp = 1;
      } else {
        this.displayScrollUp = 0;
      }
    },
    should_display_scroll_up(disp) {
      return this.displayScrollUp === disp;
    },
    // eslint-disable-next-line
    scroll_up: function () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    },
    // eslint-disable-next-line
    when_ready: function () {
      setTimeout(() => {
        // eslint-disable-next-line
        console.log('Hello!');
      }, 3000);
    },
  },
  created() {
    window.addEventListener('scroll', this.scroll_listener);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scroll_listener);
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/_variables.scss';
@import '../../assets/styles/_slanted.scss';
$hero-height: 100vh;

.hero-container {
  background-attachment: fixed;

  @include media-breakpoint-down(sm) {
    background-attachment: scroll;
  }

  background-image: url('/static/images/space_background/top-space-high.jpg'), url('/static/images/space_background/top-space-md.jpg'), url('/static/images/space_background/top-space-sm.jpg');
  background-position: left top, left top;
  background-repeat: no repeat, no-repeat;
  background-size: cover;
  height: $hero-height;
  text-align: center;
  align-items: center;
  justify-content: center;

  h1 {
    font-family: 'Lato';
    font-weight: 300;
    color:white; //override
  }
  h5 {
    color:white;
    font-weight: $font-weight-light;
    color:white; //override
  }
}

.hero-section {
 position: relative;
 align-items: center;
}

.scroll-icon {
  z-index: 11;
  position: absolute;
  bottom: $slanted-offset*1.1;

  @media screen and (max-height: 420px) {
    bottom: $slanted-offset*0.7;
  }

  img {
    width: 35px;

    @include media-breakpoint-up(xl) {
      width: 50px;
    }

    -webkit-animation: bob 1.5s alternate infinite;
    animation: bob 1.5s alternate infinite;
  }
}

.scroll-icon:hover {
  cursor: pointer;

  .scroll-text {
    @include media-breakpoint-up(md) {
      opacity: 1;
    }
  }
}

.scroll-text {
  color: $white-text;
  font-size: $h6-font-size;

  opacity: 0;
  -webkit-transition: opacity 0.5s;
  transition: opacity 0.5s;
}

.hero-section {
  width: 100%;
  height: 100vh;
}

.slanted-container-right {
  @include slanted-container-right(rgba(white, 1), rgba(white, 0));
  z-index: 10;
}

.scroll-up-icon {
  img {
    z-index: 16;

    width: 50px;
    height: 50px;

    position: fixed;
    bottom:90vh;

    right: 2rem;
    @include media-breakpoint-up(lg) {
      right: 8rem;
    }
    border: $white-text solid 2px;
    border-radius: 50%;
  }

  img:hover {
    cursor: pointer;
    transform: scale(1.2);
  }
}

@keyframes bob {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(10px);
  }
}

</style>
